(function () {
	'use strict';
	$(document).ready(function () {
		$('.publications.subpage .filters button').on('click', function() {
			const checkboxContainer = $(this).siblings('.checkboxes');
			if(!checkboxContainer.hasClass('open')) {
				closeCheckboxes();
			}
			checkboxContainer.slideToggle().toggleClass('open');
		});
		clickedOutside('.checkboxes.open', closeCheckboxes, ['.publications.subpage .filter-button']);

		function closeCheckboxes() {
			$('.publications.subpage .checkboxes.open').removeClass('open').slideUp();
		}

		function debounce(func, wait) {
			let timeout;
			return function(...args) {
				const context = this;
				clearTimeout(timeout);
				timeout = setTimeout(() => func.apply(context, args), wait);
			};
		}

		function submitForm() {
			closeCheckboxes();
			document.getElementById('filterForm').submit();
		}

		const debouncedSubmitForm = debounce(submitForm, 500);

		document.querySelectorAll('.publications.subpage #filterForm input[type="checkbox"]').forEach(checkbox => {
			checkbox.addEventListener('change', debouncedSubmitForm);
		});
	});
}(jQuery));